<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center">
                <h1 class="">Coralstone Capital</h1>
                <p class="">We are group of companies committed to meeting all your financial needs without hassles</p>
            </div>
        </div>
    </section>

    <!-- Who we are -->
    <section class="who-we-are">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
              <div class="who-we-are-text">
                  <h3>Who are we?</h3>
                  <p>Coralstone Capital Limited is a group of companies that exist to power the dreams of everyday people by providing them with premium financial services tailored to suit their financial needs.</p>
                  <p>From low-interest loans to high-yield investments, asset management, and financial advisory, we take your side and protect your financial interest.</p>
                  <p>We deploy the finest combination of financial expertise, advanced technology and professional service to help you plan, manage, and build sustainable wealth.</p>
                  <p>Our clients love us because we demystify money management and give them fast and easy access to high-value financial services while guiding them to a future of financial security.</p>
              </div>
          </div>
          <div class="col-md-6">
            <div class="who-we-are-img-wrapper">
              <picture>
                  <source media="(max-width: 575px)" srcset="/img/mobile/who-we-are-image-mobile.svg">
                  <source media="(min-width: 768px)" srcset="/img/Group-658.png">
                  <img src="/img/Group-658.png" alt="" class="img-fluid">
                </picture>
              <!-- <img src="/img/Group-658.svg" alt="" class="img-fluid"> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- imprint section -->
    <section class="imprint">
      <div class="container">
          <h3 class="text-center mb-4">Our Imprints</h3>
          <div class="row">
            <div class="col-md-6 col-lg-3">
              <div class="card text-center">
                <img src="/img/icons/imprint-icon.svg" class="card-img-top" alt="Vale Finance Icon">
                <div class="card-body">
                  <h5 class="card-title finance">Vale Finance</h5>
                  <p class="card-text">Vale Finance is a registered finance company with the responsibility to provide financial intermediary services to individuals and corporate clients, including medium-sized companies in Nigeria.</p>
                  <router-link to="/vale-finance" class="finance">Learn More</router-link>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="card text-center">
                <img src="/img/icons/vantlead-imprint-icon.svg" class="card-img-top" alt="VantLead Icon">
                <div class="card-body">
                  <h5 class="card-title global-tech">VantLead Tech</h5>
                  <p class="card-text">VantLead Tech is our technology arm that focuses on developing highly functional digital solutions that empower businesses to serve their customers seamlessly and achieve their business goals faster.</p>
                  <router-link to="/vantlead-tech" class="global-tech">Learn More</router-link>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="card text-center">
                <img src="/img/icons/imprint-icon-3.svg" class="card-img-top" alt="Vale Asset Management Icon">
                <div class="card-body">
                  <h5 class="card-title asset-mgt">Vale Asset Management</h5>
                  <p class="card-text">When fully functional, Vale Asset Management aims to take over the fund management services currently provided in part by Vale Finance, with two core responsibilities: (1) to preserve capital...</p>
                  <router-link to="/vale-asset-management" class="asset-mgt">Learn More</router-link>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="card text-center">
                <img src="/img/icons/imprint-icon-4.svg" class="card-img-top" alt="Ambission Icon">
                <div class="card-body">
                  <h5 class="card-title bdc">Ambission BDC</h5>
                  <p class="card-text">Ambission BDC is licensed by the Central Bank of Nigeria (CBN) to operate as a foreign exchange company, dealing in large-volume wholesale as well as retail trades of major global currencies.</p>
                  <router-link to="/ambission" class="bdc">Learn More</router-link>
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/Hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
      }
  }

  // who we are styles
  h3 {
    font-weight: bold;
    font-size: 48px;
    line-height: 72px;
    letter-spacing: 0.02em;
    color: map-get($colors, deep-blue);
  }
  .who-we-are {
     margin-top: 3rem;
    .who-we-are-text {

      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.02em;
        color: #0D0D26;
      }
    }
  }

  // imprint
  .imprint {
    background: url('../../public/img/imprint-wrapper.svg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 12rem 0 9rem;

    .card {
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
      border-radius: 16px;
      height: 445px;

      img {
        height: 4rem;
        margin-top: 3rem;
      }

      h5 {
        font-weight: bold;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.02em;
        
      }

      .finance {
        color: #94248C;
        position: relative;
      }

      .finance::before {
        width: 100px;
        height: 5px;
        color: #04ACEC;
      }

      .global-tech {
        color: #04ACEC;
      }

      .asset-mgt {
        color: #2C3C90;
      }

      .bdc {
        color: #171F4A;
      }

      p, a {
        
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.02em;
      }

      p {
        color: #666670;
        margin-bottom: 1.3rem;
      }

      a {
        font-weight: 600;
        text-transform: uppercase;
      }
    }
    
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 64px;
                line-height: 96px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }

    h3 {
      font-size: 42px;
    }

     .who-we-are {
      margin-top: 0;
    }
  }

  @media (max-width: 991px) {
    .imprint {
      .card {
        margin-bottom: 1.5rem;
        height: 359px;
      }
    }
  }

  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 52px;
                line-height: 76px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 5rem;
            }
        }
    }

    h3 {
      font-size: 38px;
    }

    .who-we-are {
      margin-top: -2rem;

      .who-we-are-text {
        // margin-top: 3rem;
      }
    }
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 42px;
                line-height: 57px;
            }

            p {
                font-size: 20px;
                line-height: 32px;
                padding: 0 3rem;
            }
        }
    }

    h3 {
      font-size: 32px;
      text-align: center;
    }

    .who-we-are {
      margin-top: -3rem;
      .who-we-are-text {
        
        p {
          text-align: center;
        }
      }
    }

    .imprint {
      padding-bottom: 3rem;

      .card {
        height: 95%;
      }
    }
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 6rem;

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    .who-we-are {
      position: relative;
      .who-we-are-img-wrapper {
        
        
        img {
          position: absolute;
          right: 0;
          margin-top: -1rem;
          height: 12rem;
        }
      }
    }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    
  }


</style>
